<span *ngIf="!isLoading">
	<!-- <button (click)="test()">test</button> -->
	<h3 *ngIf="isShowCCDown" style="color: red;">Due to circumstances beyond our control, we are unable to process
		credit card payments online at this time. We apologize for any inconvenience this may cause.</h3>
	<h1 class="page-title">{{firstName}} <span *ngIf="middleName">{{middleName}} </span> {{lastName}}<span
			*ngIf="suffix">, {{suffix}}</span></h1>
	<!-- 	<div *ngIf="profile && ((profile.ccpStatus && profile.ccpStatus.reinstate) || (profile.ccpStatusAEC && profile.ccpStatusAEC.reinstate))" style="color: red"><p><strong>Go to Credential Maintenance on the menu for important information about your 
		expired credentials.</strong></p></div> -->

	<div *ngIf="isBadPayment" style="color: red; padding-bottom: 5px;">
		<p><strong>Before you can proceed, you must contact our office at <a
					href="email:cmpsupport@nbrc.org">CMPSupport@nbrc.org</a> or 913.895.4900.</strong></p>
		<p *ngIf="profile && profile.ccpStatus && profile.ccpStatus.hasExpiredCredentials">If you do not enter CEUs and
			pay the $250 reinstatement fee by September 30, 2026 you must successfully complete the examination to
			reinstate your expired credential. If your credential expires, you must apply and pass the examination to
			reinstate your credential. If you have more than one expired credential, you must apply for and pass all
			examinations to reinstate your expired
			credentials. If you successfully complete the examination, your credential will be reinstated.
		</p>
	</div>

	<div *ngIf="hasFreeExam()" style="padding-bottom: 1em;">
		See ‘Eligible Exams’ below to find your second-chance-free examination. To claim the second-chance-free
		guarantee examination, you must reapply and take the same examination by December 31, 2025. The offer will not
		be valid after this time.
	</div>
	<div *ngIf="profile && profile.freeServices && !isUnderNBRCJE" style="padding-bottom: 5px;">
		You recently earned a new credential. Congratulations! A digital version of the certificate recognizing that
		accomplishment
		can be found under 'My Documents' on the left navigation bar. You may request a free printed copy of that
		certificate
		and a wallet card within one year of earning your credential by selecting 'Order Products' from the left
		navigation bar.
	</div>
	<div *ngIf="profile && profile.ccpStatus && profile.ccpStatus.hasExpiredCredentials && !isBadPayment"
		style="color: red">
		<div [innerHTML]="profile.ccpStatus.expiredCredentialMessage"></div>
	</div>
	<div *ngIf="profile && profile.ccpStatus && profile.ccpStatus.flagForAudit">
		You have been selected to provide documentation of the CE information you entered as part of our random audit
		process.
		To complete your recertification, you must submit the information below by {{profile.ccpStatus.auditDue | date :
		"M/d/yyyy"}}:
		<ul>
			<li>A copy of the certificate for each CE course you entered. All certificates must include your name, date
				of completion and the number of hours awarded.</li>
			<li>A copy of this notice or the email sent to you.</li>
		</ul>
		Submit copies of the CE completion certificates by fax to 913.712.9283 or by email in a single PDF file to
		Service@nbrc.org. Do not send screenshots and/or photos of CE completion certificates.
		If you have questions regarding this, please contact us at 913.895.4900 or Service@nbrc.org.
	</div>
	<div *ngIf="isUnderNBRCJE && profile.underNBRCJEAction !== ''" style="color: red">
		Your access to the Practitioner Portal is limited due to suspension of your {{profile.underNBRCJEAction}}.
		Please contact the NBRC Executive Office at <a href="tel:9138954900">913.895.4900</a> or <a
			href="mailto:je@nbrc.org">je@nbrc.org</a> for more information.
	</div>
	<div *ngIf="isUnderNBRCJE && profile.underNBRCJEAction === ''" style="color: red">
		Your access to the Practitioner Portal is limited due to NBRC judicial and ethics actions.
		Please contact the NBRC Executive Office at <a href="tel:9138954900">913.895.4900</a> or <a
			href="mailto:je@nbrc.org">je@nbrc.org</a> for more information.
	</div>

	<div class="credential-list item-list" *ngIf="this.credentials && !isUnderNBRCJE">
		<header class="item-list__header">
			<h2 class="item-list__title">Earned Credentials</h2>
			<a routerLink="practitioner/purchase-history" href="#">View Purchase History</a>
		</header>
		<div style="display: flex; justify-content: space-between;">
			<div>
				<div class="credential" *ngFor="let item of credentials; let i = index;">
					<div *ngIf="!isExpired(item.expirationDate) && !(revokedCRT && item.credential==='CRT')"><i
							class="icon icon--check-circle credential__icon credential__icon--completed"></i></div>
					<div *ngIf="isExpired(item.expirationDate) || (revokedCRT && item.credential==='CRT')"><i
							style="color:red" class="icon icon--close credential__icon credential__icon--completed"></i>
					</div>
					<div class="credential__text-wrap">
						<h3 *ngIf="needsBaseCredential(item.credential)" class="credential__title">
							{{item.baseCredential}}-{{item.credential}}</h3>
						<h3 *ngIf="!needsBaseCredential(item.credential)" class="credential__title">{{item.credential}}
						</h3>
						<div class="data-list data-list--inline"
							[ngStyle]="{'color':isExpired(item.expirationDate) ? 'red': 'black' }">
							<div class="data-item data-item--inline ">
								<div class="data-item__label label">Earned</div>
								<div *ngIf="!altCredentialDate(item, '1901-01-01') && !altCredentialDate(item,'1909-09-09')"
									class="data-item__value">{{item.certificationDate | amDateFormat: 'L'}}</div>
								<div *ngIf="altCredentialDate(item,'1909-09-09')">N/A</div>
								<div *ngIf="altCredentialDate(item,'1901-01-01')">Please contact our office regarding
									your credential date.</div>
							</div>
							<div *ngIf="item.expirationDate !== null" class="data-item data-item--inline">
								<div class="data-item__label label">Expires</div>
								<div class="data-item__value">{{item.expirationDate | amDateFormat: 'L'}}</div>
							</div>
							<div *ngIf="item.credential === 'RRT'" class="data-item data-item--inline">
								<div class="data-item__label label">Registry #</div>
								<div class="data-item__value">{{item.registryNumber}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="showBadgePage()" style="display: flex; flex-direction: column; margin: auto 0;">
				<div>
					<a routerLink="practitioner/badge" href="#"><img src="./assets/images/NBRC Digital Badge.jpg"
							alt="NBRC Digital Badge Icon" style="width:200px;"></a>
				</div>
				<div class="data-item data-item--inline" style="margin: .90em auto;">
					<a routerLink="practitioner/badge" href="#">Manage Digital Badge</a>
				</div>
			</div>
		</div>
		<div *ngIf="isProvisional()" style="color:red;">
			Expiration provisionally extended to 12/31/2020 due to COVID-19 pandemic and will revert to expired status
			on 1/1/2021.
		</div>
	</div>

	<header *ngIf="!isUnderNBRCJE" class="item-list__header">
		<h2 class="item-list__title">Eligible Exam(s)</h2>
	</header>

	<div [class.col-wrap]="!isCredentialed && !isUnderNBRCJE">
		<div [class.col]="!isCredentialed" [class.col--primary]="!isCredentialed">
			<p *ngIf="isProvisional()">Check back after your credential reverts to expired on January 1, 2021 to apply
				for eligible exams.</p>
			<p *ngIf="eligibleExams.length === 0 && !isScheduledExams">
				You are currently not eligible for any exams. <a href="https://www.nbrc.org/examinations/"
					target="_blank">How do I become eligible?</a>
			</p>
			<p *ngIf="eligibleExams.length === 0 && isScheduledExams">
				Please wait 2 business days from your scheduled examination appointment for our records to be updated.
			</p>
			<p *ngIf="isContactFlagged">
				<strong>Please contact our office regarding your eligibility for NBRC examinations.</strong>
			</p>
			<div *ngIf="isBadPayment">
				<strong>Please contact our office regarding your status.</strong>
			</div>
			<div class="credential-list item-list" *ngIf="eligibleExams.length > 0 && !isBadPayment && !isUnderNBRCJE">
				<p>
					According to our records, you are eligible to apply for the examination(s) listed below.
					To begin the application process, click on the examination you wish to apply for.
					To apply for an examination not listed below, please submit a paper <a
						href="https://www.nbrc.org/paper-application" target="_blank">application</a> to our office for
					processing.
				</p>
				<p *ngIf="isPSIDown"><strong>Due to technical issues affecting our testing partner, PSI, examination
						appointments cannot be scheduled at this time. Candidates may continue to apply for the
						examination; however, it may take up to 24-48 hours before scheduling becomes
						available.</strong>
				</p>
				<div *ngIf="!holdsRRT()" class="section">
					<strong>NOTICE:</strong> If you are eligible for the RRT credential and have passed the Therapist
					Multiple-Choice Examination at the high cut,
					it can take up to two business days from the date you passed the examination for the Clinical
					Simulation Examination to appear in the section below.
				</div>
				<div *ngIf="eligibleForRTandTMC()" class="section">
					<a href="javascript:void(0)" (click)="openExamInfo('TMC')">
						<strong>Click here for important information before applying for either the RT Examination or
							TMC Examination.</strong>
					</a>
				</div>
				<div *ngIf="eligibleForRTandCSE()" class="section">
					<a href="javascript:void(0)" (click)="openExamInfo('CSE')">
						<strong>Click here for important information before applying for either the RT Examination or
							CSE Examination.</strong>
					</a>
				</div>

				<div class="credential" *ngFor="let exam of eligibleExams">
					<div *ngIf="!sunsetCSEorTMC(exam.examCode) || exam.applicationStatus && (exam.applicationStatus === 'ELIG'||exam.applicationStatus === 'SCHED')">
						<i class="icon icon--check-circle credential__icon "></i>
						<div class="credential__text-wrap">
							<h3 class="credential__title">{{exam.examCode}}</h3>
							<p
								*ngIf="exam.cost === 0 && (exam.applicationStatus === null || exam.applicationStatus === 'INCMP')">
								Select this examination for your second-chance-free.</p>
							<p class="credential__message" *ngIf="displayEligibilityEndDate(exam) && exam.eligibilityEndDate 
														&& (exam.applicationStatus === 'ELIG' || exam.applicationStatus === 'SCHED')">
								You must schedule and take your examination by {{exam.eligibilityEndDate | date :
								"M/d/yyyy"}}.
							</p>
							<p class="credential__message" *ngIf="exam.waitMessage">
								{{exam.waitMessage}}
							</p>
							<!-- <p class="credential__message" *ngIf="exam.examInstructions">
							{{exam.examInstructions}}
						</p> -->
						</div>
						<!-- <button *ngIf="!exam.schedulingLink" [disabled]="exam.waitMessage" class="button button--alt credential__button" [routerLink]="['purchase/checkout/exam', exam.examCode, exam.collectBirthday, exam.reinstatementFee]" skipLocationChange>Pay &amp; Schedule Exam</button>
					<button *ngIf="exam.schedulingLink" class="button button--alt credential__button" (click)="onScheduleExamClick(exam.schedulingLink)">View Scheduling Instructions</button> -->
						<button *ngIf="!sunsetCSEorTMC(exam.examCode) &&
						(
						(!exam.applicationStatus && !exam.isSubjectToDisciplineAudit) ||
						(!exam.isSubjectToDisciplineAudit &&
						exam.applicationStatus !== 'ELIG' &&
						exam.applicationStatus !== 'SCHED')
						)" [disabled]="exam.waitMessage" class="button button--alt credential__button" [routerLink]="['purchase/checkout/exam', exam.examCode,
						exam.collectBirthday, exam.collectDemographics,
						exam.reinstatementFee, exam.collectDiscipline]" skipLocationChange>
							Pay &amp; Schedule Exam
						</button>
						<button *ngIf="(exam.isSubjectToDisciplineAudit && !exam.disciplineFileAuditUploaded)"
							[disabled]="exam.waitMessage" class="button button--alt credential__button"
							[routerLink]="['practitioner/mydocuments/upload', personId]" skipLocationChange>
							Upload License or Credential
						</button>
						<button *ngIf="(exam.isSubjectToDisciplineAudit && exam.disciplineFileAuditUploaded)"
							[disabled]="exam.disciplineFileAuditUploaded" class="button button--alt credential__button"
							[routerLink]="['practitioner/mydocuments/upload', personId]" skipLocationChange>
							Document Under Review
						</button>
						<button
							*ngIf="exam.applicationStatus && (exam.applicationStatus === 'ELIG'||exam.applicationStatus === 'SCHED')"
							class="button button--alt credential__button"
							(click)="onScheduleExamClick(exam.schedulingLink)">
							Schedule/Reschedule Exam
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="col col--secondary col--separator" *ngIf="!isCredentialed">
			<div class="user-contact-info">
				<header class="user-contact-info__header">
					<h3 class="user-contact-info__heading">Contact Info</h3>
					<a href="#" routerLink="practitioner/profile/edit">Edit Profile</a>
				</header>
				<div class="user-contact-info__address">
					<div>{{profile?.line1}}</div>
					<div>{{profile?.line2}}</div>
					<div>{{profile?.city}}, {{profile?.stateProvince}} {{profile?.zip}}</div>
				</div>
				<div>
					<a href="mailto:{{profile?.email}}">{{profile?.email}}</a>
				</div>
				<div>
					home: <a href="tel:{{profile?.homePhone}}">{{profile?.homePhone}}</a>
				</div>
				<div>
					cell: <a href="tel:{{profile?.cellPhone}}">{{profile?.cellPhone}}</a>
				</div>
			</div>
		</div>
	</div>
</span>
<div class="exam-info-backdrop" *ngIf="showExamInfo" (click)="closeExamInfo()">
	<div class="exam-info-modal" (click)="$event.stopPropagation()">

		<button type="button" class="modal-close" aria-label="Close" (click)="closeExamInfo()">
			×
		</button>

		<h2>Important Examination Application Information</h2>

		<span *ngIf="examInfoType === 'TMC'">
			<p>
				Please be advised of the following before selecting either the
				RT Examination or TMC Examination below:
			</p>

			<h3>
				Candidates Who Do Not Pass the TMC Examination by December 31, 2026
			</h3>

			<ul>
				<li>
					Candidates who do not achieve a passing score on the TMC Examination
					by December 31, 2026, must meet the eligibility requirements and apply
					for the RT Examination.
				</li>
			</ul>

			<h3>
				Candidates Who Pass the TMC Examination at the Low Cut Score by
				December 31, 2026
			</h3>

			<ul>
				<li>
					Candidates who pass the TMC Examination at the low cut score may
					continue to take the TMC Examination to attempt to achieve the high cut
					score and, if eligible, qualify for the Clinical Simulation Examination
					(CSE) through December 31, 2026.
				</li>

				<li>
					Candidates who do not achieve the high cut score by December 31, 2026,
					must meet the eligibility requirements and apply for the RT Examination.
				</li>
			</ul>

			<h3>
				Candidates Who Achieve the High Cut Score on the TMC Examination Before
				December 31, 2026, May:
			</h3>

			<ul>
				<li>
					Take the Clinical Simulation Examination (CSE) through December 31,
					2027; or
				</li>

				<li>
					Elect to take the new RT Examination beginning January 1, 2027, if
					current eligibility requirements are met.
				</li>
			</ul>

			<p class="important-note">
				<strong>
					Please note that once a candidate applies for the RT Examination,
					they are no longer eligible to apply for the CSE.
				</strong>
			</p>
		</span>
		<span *ngIf="examInfoType === 'CSE'">
			<p>
				Please be advised of the following before selecting either the
				RT Examination or CSE Examination below:
			</p>

			<p>You have the following options for earning the RRT credential:</p>
			<ul>
				<li>Take and pass the Clinical Simulation Examination (CSE) through December 31, 2027; or</li>
				<li>Elect to take and pass the new RT Examination beginning January 1, 2027, if current eligibility
					requirements are met.</li>
			</ul>
			<p>Please note that once you apply for the RT Examination, you are no longer eligible to apply for the CSE.
			</p>
		</span>

		<div class="modal-actions">
			<button type="button" class="button" (click)="closeExamInfo()">
				Close
			</button>
		</div>

	</div>
</div>